import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};
type GetAllRolesResponse = {
  SubAdminAccess: RoleResponse[];
  count: number;
};

export type RoleResponse = {
    _id: string 
    name: string
    permission:Permission[]
    isDeleted: boolean,
    isBlocked: boolean,
    createdAt: string,
    updatedAt: string,
    __v: number
}

 export type Permission = 
  {
      sideBarId: number|string,
      label: string
      isView: boolean,
      isAdd: boolean,
      isEdit: boolean,
      isDelete: boolean,
      _id: string
  }

type GetTokenParams = {
  wpagination?: boolean;
  limit?: number;
  page?: number;
  query?: string;
  categoryType?: number;
};
export const accessRoleApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRoles: builder.query<
      CommonResponseType & { data: any },
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url: `${END_POINTS.role}?from=${from}&size=${size}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
    getRoleById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.role}/${id}`,
        method: "GET",
      }),
    }),
    addRole: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.role,
        method: "POST",
        body,
      }),
    }),
    updateRoleById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.role}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteRoleById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.role}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllRolesQuery,
  useLazyGetRoleByIdQuery,
  useAddRoleMutation,
  useUpdateRoleByIdMutation,
  useDeleteRoleByIdMutation,
} = accessRoleApi;
